<template>
  <v-container fluid class="salesorder-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/salesorder/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="isFindDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-3" @click="makeDepositList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Deposit
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_orders.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/batchdeposit/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Deposits
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_select"
              loading-text="Loading... Please wait"
              class="salesorders-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_orders"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Sales Order?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_salesorder.salesordernum }} 
                      {{ delete_salesorder.salesordername }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_salesorder)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line" style="margin-left: 0px;">
                    <v-avatar v-if="item.userid!=null && users.length>0" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <p class="two-line"><span class="white--text headline">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                    </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:0px; font-size: 9pt;">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span></p>
                </div>
              </template>
              <template v-slot:item.salesorderimage="{ item }">
                    <v-img
                    v-if="item.salesorderimage" 
                    v-bind:src="item.salesorderimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.deposits="{ item }">
                <div v-if="item.deposits" style="font-size: 10pt;">{{ item.deposits.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount}`).join('\n') }}</div>
              </template>
              <template v-slot:item.salesordernum="{ item }">
                
                <p class="two-line">{{ item.salesordertype  }}</p>
                <p class="two-line">{{ item.salesordernum  }}</p>
                <p v-if="item.salesorderdate!=undefined" class="two-line">{{ new Date(item.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
                <p v-if="item.salesorderdate!=item.salesorderpostdate" class="two-line"><b>Post: {{ new Date(item.salesorderpostdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
                <p v-if="item.salesordertype=='Credit Order'" class="two-line"><b>Due: {{ new Date(item.salesorderduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
              </template>
              
              <template v-slot:item.salesordername="{ item }">
                <p class="two-line" style="font-size: 10pt;">{{ item.salesordername }}</p>
                <p class="two-line" style="font-size: 10pt;">{{ item.salesorderaddress }}</p>
                <p class="two-line" style="font-size: 10pt;" v-if="item.regionid!=undefined">
                  <span v-if="item.regionid">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }}&nbsp;-&nbsp;</span>
                  <span v-if="item.townshipid">{{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}&nbsp;-&nbsp;</span>
                  <span>{{ item.customertype }}</span>
                </p>
                <p class="two-line" v-if="item.locationid!=undefined">
                  <span v-if="item.locationid && locations.find(location=>location._id == item.locationid)!=null">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : ''  }}&nbsp;-&nbsp;</span> 
                  <span v-if="item.channelid">{{ saleschannels.length>0 ? saleschannels.find(channel=>channel._id == item.channelid)['channelcode'] : ''  }}</span>
                </p>
                </template>
              <template v-slot:item.salesordertotal="{ item }">
                <p class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.salesordertotal.toLocaleString('en-SG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
                <p v-if="item.paymethodid!=null" class="two-line" style="font-size: 9pt;">{{ paymethods.length>0 ? paymethods.find(method=>method._id == item.paymethodid)['paymethodcode'] : ''  }}</p>
                <p v-if="item.salesorderstatus=='New' && item.paymethodid!=null && getPayMethod(item.paymethodid, item._id, 'paymethodlink')!=''" class="two-line" style="font-size: 9pt;">
                  <a :href="getPayMethod(item.paymethodid, item._id, 'paymethodlink')" target="_blank">Payment Link</a>
                </p>
              </template>
              <template v-slot:item.salesorderstatus="{ item }">
                <v-chip
                  v-if="item.salesorderstatus!=undefined"
                  :color="getStatusColor(item.salesorderstatus)" 
                  small>
                  {{ item.salesorderstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.salesorderstatus=='Pending'" icon color="primary" @click="updateOrderProcessingDialog(item)">
                  <v-icon>mdi-text-box-edit</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.salesorderstatus!=='Completed'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isFindDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Orders</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="find_query.locationid"
                  label="Location"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="find_query.userid"
                  label="Sales Rep"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="paymethods.filter(x=>x.paymethodstatus=='Active').map(x => {
                            return {text: `${x.paymethodcode}`, value: x._id};
                          })"
                  v-model="find_query.paymethodid"
                  label="Payment Method"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['Cash Order', 'Credit Order', 'Pre Order', 'Sales Order']"
                  v-model="find_query.ordertype"
                  label="Order Type"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-select
                  :items="['New', 'Credit', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                  v-model="find_query.orderstatus"
                  label="Order Status"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  class="mb-4"
                  type="number"
                  placeholder="Order Num"
                  v-model="find_query.ordernum"
                  dense
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line hint="Order Num">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetSalesOrders"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesOrders"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="isProcessingSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Process Order</span>
            </v-card-title>
            <v-card-text>
              {{ processing_send.salesordertype }} {{ processing_send.salesordernum }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="processing_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Confirm'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isProcessingSend=false; processing_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="processing_send.confirm!=='Confirm'"
                @click="updateOrderProcessing"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'SalesOrderList',
  data() {
    return {
      config,
      
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindDialog: false,
      isProcessingSend: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_salesorder: {},
      find_query: {},
      processing_send: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Image', value: 'salesorderimage', sortable: false, width: "5%"  },
        { text: 'Order', value: 'salesordernum', sortable: false, width: "15%" },
        { text: 'Name', value: 'salesordername' },
        { text: 'Amount', value: 'salesordertotal', width: "8%" },
        { text: 'Received', value: 'deposits', width: "8%" },
        { text: 'Sales Rep', value: 'userid', width: "10%"  },
        { text: 'Status', value: 'salesorderstatus', width: "8%"  },
        { text: 'Tax', value: 'isTaxable', width: "2%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%"  },
      ],
      data_orders: [],
      data_select: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('SalesOrder', ['salesorders', 'isReceiving', 'isDeleting', 'idToDelete', 'salesordersMessage', 'isUpdating']),
    ...mapState('PayMethod', ['paymethods']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('SalesOrder', ["getSalesOrdersRequest", "findSalesOrdersRequest", "deleteSalesOrderRequest","updateSalesOrderRequest","updateSalesOrderProcessingRequest"]),
    ...mapActions('PayMethod', ["getPayMethodsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getPayMethod(id, orderid, name){
      let method = this.paymethods.find(i=>i._id==id);
      if(method!=null){
        if(name=='paymethodlink') return `${method[name].replace("${id}", orderid)}`;
        else return method[name];
      }
      return null;
    },
    getJson(){
      let json = this.data_orders.map(order=>{return {
        ordernum: order.salesordernum, 
        orderdate: order.salesorderdate!=undefined ? new Date(order.salesorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.salesorderdate!=undefined ? new Date(order.salesorderdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.salesordertype,
        customer_name: order.salesordername, 
        customer_address: order.salesorderaddress,
        customertype: order.customertype,
        region: order.regionid!=null && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        location: order.locationid!=null && this.locations.find(location=>location._id == order.locationid)!=null && this.locations.length>0 ? this.locations.find(location=>location._id == order.locationid)['locationname'] : '',
        channel: order.channelid!=null && this.saleschannels.length>0 ? this.saleschannels.find(channel=>channel._id == order.channelid)['channelname'] : '',
        salesrep: order.userid!=null && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        payment_method: order.paymethodid!=null && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        status: order.salesorderstatus,
        tax: order.salesordertaxamount,
        subtotal: order.salesordersubtotal,
        total: order.salesordertotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.data_select.length==0) return false;
      if(this.data_select.find(item=>item.salesorderstatus=='Completed')!=null) return false;
      return true;
    },
    checkSalesOrders(){
      return this.data_select.filter(item=>item.salesorderstatus=='Completed').map(item=>item.salesordernum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    makeDepositList(){
      if(!this.checkError()) {
        if(this.data_select.length==0) this.dialogMessage='No Sales Orders selected';
        else this.dialogMessage='The following Sales Orders cannot be deposited:  ' + this.checkSalesOrders();
        this.dialogAlert=true; 
        return;
      }
      let orders = Object.assign([], this.data_select);
      let json = {orders: orders, isSalesOrders: true};
      this.$router.push({ name: 'BatchDepositAdd', params: json });
    },
    makeDeliveryList(){
      //this.$router.push({ name: 'DeliveryListAdd', params: this.data_select });
    },
    editItem(item) {
      this.$router.push({ name: 'SalesOrderEdit', params: item });
    },
    printItem(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'SalesOrderPrint', params: item });
    },
    viewItem(item) {
      item['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'SalesOrderView', params: item });
    },
    async findSalesOrders(){
      this.isFindDialog = false;
      if(this.find_query=={}){
        await this.getSalesOrdersRequest();
        this.data_orders = Object.assign([], this.salesorders);
        this.data_orders.push({salesordertotal: this.salesorders.reduce(function (last, json) {return last + json.salesordertotal;}, 0) });
      }
      else{
        let result = await this.findSalesOrdersRequest(this.find_query);
        this.data_orders = Object.assign([], result);
        console.log(this.data_orders)
        this.data_orders.push({salesordertotal: result.reduce(function (last, json) {return last + json.salesordertotal;}, 0) });
      }
    },
    async resetSalesOrders(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteSalesOrderRequest({_id: item._id});
      this.data_orders = this.salesorders;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.delete_salesorder = {
        _id: item._id,
        salesordernum: item.salesordernum,
        salesordername: item.salesordername,
      }
    },
    updateOrderProcessingDialog(item) {
      this.isProcessingSend = true;
      this.processing_send = {
        _id: item._id,
        salesordernum: item.salesordernum,
        salesordertype: item.salesordertype,
      };
    },
    async updateOrderProcessing() {
      this.isProcessingSend = false;
      let result = await this.updateSalesOrderProcessingRequest(this.processing_send);
      let index = this.data_orders.findIndex((x) => x._id == result._id);
      this.data_orders.splice(index, 1, result);
      this.processing_send = {};
    },
  },
  async created () {
    if(this.$route.params.isDeposit==true) this.data_select = this.$route.params.orders;
    if(this.salesorders.length==0) await this.getSalesOrdersRequest();
    this.data_orders = Object.assign([], this.salesorders);
    this.data_orders.push({salesordertotal: this.salesorders.reduce(function (last, json) {return last + json.salesordertotal;}, 0) });
    if(this.paymethods.length==0) await this.getPayMethodsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    console.log(this.data_orders)
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
